import UserMenuPanel from 'features/UserMenu/components/UserMenuPanel/UserMenuPanel';
import { IoCallOutline, IoInformationCircleOutline, IoSparklesOutline } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { NAVIGATION_STYLES } from 'store/config/displayOptions.config';
import { selectNavigationStyle } from 'store/selectors/DisplayOptions/displayOptionsSelectors';
import { aboutContacts, aboutContent, aboutFeatures } from './config/about.config';
import './assets/about.scss';

/** Show company information in one layout with colors for the selected appearance. */
const About = () => {
  const navigationStyle = useSelector(selectNavigationStyle);
  const isClassic = navigationStyle === NAVIGATION_STYLES.CLASSIC;
  const { company, platform, contactTitle, weatherProvider } = aboutContent;

  return (
    <div className="user-menu-page about-page" data-appearance={isClassic ? 'classic' : 'merlin'}>
      <UserMenuPanel icon={<IoInformationCircleOutline />} title={company.title}>
        <div className="user-menu-hero">
          <img src={company.logo} alt="" />
          <h3>{company.subtitle}</h3>
        </div>
        <p className="user-menu-lead">{company.description}</p>
        <div className="user-menu-feature-grid">
          {aboutFeatures.map((feature) => (
            <div key={feature.title} className="user-menu-feature">
              <img src={feature.icon} alt="" />
              <div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            </div>
          ))}
        </div>
      </UserMenuPanel>

      <UserMenuPanel icon={<IoSparklesOutline />} title={platform.title}>
        <p className="user-menu-lead">{platform.description}</p>
        <a
          className="user-menu-link align-self-start"
          href={platform.href}
          target="_blank"
          rel="noreferrer"
        >
          {platform.linkLabel}
        </a>
      </UserMenuPanel>

      <UserMenuPanel icon={<IoCallOutline />} title={contactTitle}>
        <div className="user-menu-feature-grid">
          {aboutContacts.map((contact) => (
            <div key={contact.title} className="user-menu-feature">
              <img src={contact.icon} alt="" />
              <div>
                <h3>{contact.title}</h3>
                <a className="user-menu-link about-contact-link" href={contact.href}>
                  {contact.label}
                </a>
              </div>
            </div>
          ))}
          <div className="user-menu-feature flex-column">
            <img
              className="user-menu-partner-logo"
              src={weatherProvider.logo}
              alt={weatherProvider.name}
            />
            <div>
              <p>{weatherProvider.description}</p>
              <a
                className="user-menu-link"
                href={weatherProvider.href}
                target="_blank"
                rel="noreferrer"
              >
                {weatherProvider.href}
              </a>
            </div>
          </div>
        </div>
      </UserMenuPanel>
    </div>
  );
};

export default About;
